import { gql } from "@apollo/client";
import { ZoneOption } from "./SearchPayeeZones";

/**
 * Resolves zone names from their ids -- for zone pickers and filters whose selected values arrive
 * as bare ids (e.g. restored from a URL) before any search has loaded them as options.
 */
export const GET_ZONE_NAME = gql`
  query GetZoneName($zoneIds: [uuid!]!) {
    zones(where: { id: { _in: $zoneIds } }) {
      id
      name
    }
  }
`;

export interface GetZoneNameData {
  zones: ZoneOption[];
}

export interface GetZoneNameVars {
  zoneIds: string[];
}

export default GET_ZONE_NAME;
